import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChartMixed } from "@fortawesome/pro-solid-svg-icons";
import {
  faGrid2,
  faNoteMedical,
  faForklift,
  faScrewdriverWrench,
  faHourglass,
  faSquareExclamation,
} from "@fortawesome/pro-regular-svg-icons";
import { ROLES } from "./constant";

export interface itemProp {
  id: number;
  title: string;
  path: string;
  access_role: ROLES[];
  icon: any;
  child: itemProp[];
  classname: string;
  urlCommonWord?: string;
}

export const NavbarList: itemProp[] = [
  {
    id: 1,
    title: "Dashboard",
    path: "/warehouse-dashboard",
    access_role: [
      ROLES.MANAGEMENTUSER
    ],
    icon: <FontAwesomeIcon icon={faGrid2} />,
    child: [],
    classname: "dashboard",
    urlCommonWord: "dashboard"
  },
  {
    id: 2,
    title: "Rack Health",
    path: "/rack-health",
    access_role: [ROLES.MANAGEMENTUSER],
    icon: <FontAwesomeIcon icon={faNoteMedical} />,
    child: [],
    classname: "rackhealth",
    urlCommonWord: "rack-health"
  },
  {
    id: 3,
    title: "MHE Management",
    path: "/mhe-management",
    access_role: [ROLES.MANAGEMENTUSER],
    icon: <FontAwesomeIcon icon={faForklift} />,
    classname: "mhe",
    urlCommonWord: "mhe",
    child: [
      {
        id: 1,
        child: [],
        title: "MHE Monitor",
        path: "/mhe-movement-tracking",
        access_role: [ROLES.MANAGEMENTUSER],
        icon: <FontAwesomeIcon icon={faChartMixed} />,
        classname: "mhemonitor",
        urlCommonWord: "movement",
      },
      {
        id: 2,
        child: [],
        title: "MHE Overview",
        path: "/mhe-overview",
        access_role: [ROLES.MANAGEMENTUSER],
        icon: <FontAwesomeIcon icon={faChartMixed} />,
        classname: "mheoverview",
        urlCommonWord: "mhe-overview",
      },
      {
        id: 3,
        child: [],
        title: "MHE Summary",
        path: "/mhe-sensor-summary",
        access_role: [ROLES.MANAGEMENTUSER],
        icon: <FontAwesomeIcon icon={faChartMixed} />,
        classname: "mhesummary",
        urlCommonWord: "mhe-sensor",
      },
      {
        id: 4,
        child: [],
        title: "Operator Summary",
        path: "/mhe-operator-summary",
        access_role: [ROLES.MANAGEMENTUSER],
        icon: <FontAwesomeIcon icon={faChartMixed} />,
        classname: "operatorsummary",
        urlCommonWord: "operator",
      },
    ],
  },
  {
    id: 5,
    title: "Inspection Summary",
    path: "/complete-inspection",
    access_role: [ROLES.MANAGEMENTUSER],
    icon: <FontAwesomeIcon icon={faHourglass} />,
    child: [],
    classname: "inspectionsummary",
    urlCommonWord: "complete-inspection"
  },
  {
    id: 4,
    title: "Reported Issues",
    path: "/reported-issue-summary",
    access_role: [ROLES.MANAGEMENTUSER],
    icon: <FontAwesomeIcon icon={faSquareExclamation} />,
    child: [],
    classname: "reportedissues",
    urlCommonWord: "reported-issue"
  },
  {
    id: 5,
    title: "Maintenance",
    path: "/maintenance",
    access_role: [ROLES.MANAGEMENTUSER],
    icon: <FontAwesomeIcon icon={faScrewdriverWrench} />,
    child: [
      {
        id: 1,
        title: "Verified Issues",
        path: "/verified-issue-summary",
        access_role: [ROLES.MANAGEMENTUSER],
        icon: <FontAwesomeIcon icon={faScrewdriverWrench} />,
        child: [],
        classname: "verifiedissues",
        urlCommonWord: "verified-issue"
      },
    ],
    classname: "projects",
  },
  
];
